export default __webpack_public_path__ + "static/media/1997.bcb95ead.png";